function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonoStandbyHybrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#84CC16",
    style: {
      fill: "#84CC16",
      fill: "color(display-p3 0.5176 0.8000 0.0863)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#84CC16",
    style: {
      fill: "#84CC16",
      fill: "color(display-p3 0.5176 0.8000 0.0863)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#84CC16",
    style: {
      fill: "#84CC16",
      fill: "color(display-p3 0.5176 0.8000 0.0863)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonoStandbyHybrid);
export default __webpack_public_path__ + "static/media/mono_standby_hybrid.f0657415b88a31c1d9b8ffab242d2ea7.svg";
export { ForwardRef as ReactComponent };